import { render, staticRenderFns } from "./ThemeFooter.vue?vue&type=template&id=433667dd&scoped=true&"
import script from "./ThemeFooter.vue?vue&type=script&lang=js&"
export * from "./ThemeFooter.vue?vue&type=script&lang=js&"
import style0 from "./ThemeFooter.vue?vue&type=style&index=0&id=433667dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433667dd",
  null
  
)

export default component.exports